export default "__VITE_ASSET__BPB6hyJ1__"